import React, { createContext, useState, useContext } from "react";
import SupportModal from "../components/Shared/SupportModal";

const SupportModalContext = createContext();

export const useSupportModal = () => useContext(SupportModalContext);

export const SupportModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <SupportModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <SupportModal isOpen={isOpen} isClose={closeModal} />
    </SupportModalContext.Provider>
  );
};
